import DescriptionWrapper from '../../../components/description-wrapper/DescriptionWrapper';
import styles from './organization-description.module.less';
import { formatOrganizationNumber } from '../../../utils';

export const OrganizationDescriptionShow = ({ organization }) => (
    <div>
        {organization.descriptionHtml && (
            <DescriptionWrapper className={styles.description}>
                <div dangerouslySetInnerHTML={organization?.descriptionHtml} />
            </DescriptionWrapper>
        )}

        {organization.organization_number && (
            <p className={styles.organizationNumber}>
                Organisasjonsnummer: {formatOrganizationNumber(organization.organization_number)}
            </p>
        )}
    </div>
);
